import { useEffect, useState, useRef, Fragment } from "react";
// import { useAppSelector } from "../../../redux/hooks";
// import { getTeams, getUsers } from "../../../redux/slices/tenantSlice";
import {
  DKLabel,
  DKButton,
  DKIcons,
  DKLine,
  showAlert,
  DKCheckMark,
} from "deskera-ui-library";
import {
  ACCESS_LEVEL,
  PERMISSIONS,
  SHARE_ACTION,
} from "../../../constants/Permission";

// import UserTeamRow from "../../share/UserTeamRow";
// import { IPermissionObject } from "../../../model/PermissionModel";
// import ITeam from "../../../model/Team";
import UserManager from "../../../managers/UserManager";
import Utility from "../../../utility/Utility";
import AddTeamPopup from "../../share/AddTeamPopup";
import { AUTOMATION_ACTIONS } from "../AutomationConstants";

export interface IAssignAccessActionPopupProps {
  stepData: any;
  parentStepType?: string;
  onSave: (data: any) => void;
  onClose: () => void;
}

const AssignAccessActionPopup = (props: IAssignAccessActionPopupProps) => {
  const isFirstRun = useRef(true);
  const userList = null; //useAppSelector(getUsers());
  const teamList = null//useAppSelector(getTeams());
  const currentUserId = ''//UserManager.getUserIamID();

  const [currentView, setCurrentView] = useState(SHARE_ACTION.USERS);
  const [selectedTeamToEdit, setSelectedTeamToEdit] = useState({});
  const [showAddNewTeam, setShowAddNewTeam] = useState(false);
  const [permissions, setPermissions] = useState({
    users: [],
    teams: [],
  });

  useEffect(() => {
    const existingPermissions = props.stepData?.configuration;

    let permissionsObj = existingPermissions?.otherPermissions
      ? Utility.makeCopyOfObject(existingPermissions.otherPermissions)
      : {
          users: [],
          teams: [],
        };
    permissionsObj = mergeNewAndExistingPermissions(permissionsObj);
    setPermissions(permissionsObj);
  }, []);

  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;
      return;
    }

    const newPermissions = mergeNewAndExistingPermissions(permissions);
    setPermissions(newPermissions);
  }, [userList, teamList]);

  const mergeNewAndExistingPermissions = (existingPermissions: any) => {
    const newPermissionsObj = Utility.makeCopyOfObject(existingPermissions);
    newPermissionsObj.users = newPermissionsObj.users || [];
    newPermissionsObj.teams = newPermissionsObj.teams || [];

    const existingUserSet = new Set(
      existingPermissions?.users?.map((user) => `${user.id}`)
    );
    const existingTeamSet = new Set(
      existingPermissions?.teams?.map((team) => `${team.id}`)
    );

    userList?.forEach((user: any) => {
      /* only considering onboarded users, STATUS: "JOINED" */
      if (user.iamUserId && !existingUserSet.has(user.iamUserId.toString())) {
        newPermissionsObj.users.push({
          id: user.iamUserId,
          accessLevel: ACCESS_LEVEL.CAN_EDIT,
          source: "tab_user",
          selected: false,
        });
      }
    });

    teamList?.forEach((team: any) => {
      if (team._id && !existingTeamSet.has(team._id.toString())) {
        newPermissionsObj.teams.push({
          id: team._id,
          accessLevel: ACCESS_LEVEL.CAN_EDIT,
          source: "tab_team",
          selected: false,
        });
      }
    });

    return newPermissionsObj;
  };

  const getAssignAccessObjectType = () => {
    switch (props.parentStepType) {
      case AUTOMATION_ACTIONS.CREATE_DEAL:
      case AUTOMATION_ACTIONS.UPDATE_DEAL:
        return "DEAL";
      default:
        return "CONTACT";
    }
  };

  const saveTapped = () => {
    const configs = {
      users:
        permissions.users
          ?.filter((user) => user.selected)
          .map((selectedUser) => ({
            id: selectedUser.id,
            accessLevel: selectedUser.accessLevel,
            invitationStatus: 1,
          })) || [],
      teams:
        permissions.teams
          ?.filter((team) => team.selected)
          .map((selectedTeam) => ({
            id: selectedTeam.id,
            accessLevel: selectedTeam.accessLevel,
          })) || [],
      otherPermissions: Utility.makeCopyOfObject(permissions),
      objectType: getAssignAccessObjectType(),
    };

    if (
      Utility.isEmptyObject(configs.users) &&
      Utility.isEmptyObject(configs.teams)
    ) {
      showAlert(
        "No user found",
        "Please select an org user or team to assign record access."
      );

      return;
    }

    props.onSave(configs);
  };

  const toggleTeamCreationPopup = () => {
    setShowAddNewTeam(!showAddNewTeam);
  };

  const onPermissionChange = (
    newPermission: any,
    entity: any,
    isTeam: boolean = false
  ) => {
    const newPermissions = Utility.makeCopyOfObject(permissions);

    if (isTeam) {
      const selectedTeam = newPermissions.teams.find(
        (team) => team.id === entity.id
      );
      selectedTeam &&
        (selectedTeam.accessLevel = newPermission.permissions_level);
    } else {
      const selectedUser = newPermissions.users?.find(
        (user) => user.id === entity.id
      );
      selectedUser &&
        (selectedUser.accessLevel = newPermission.permissions_level);
    }

    setPermissions(newPermissions);
  };

  const toggleUserOrTeamSelection = (e: any, userOrTeam: any) => {
    const newPermissions = Utility.makeCopyOfObject(permissions);

    if (currentView === SHARE_ACTION.USERS) {
      const selectedUser = newPermissions.users.find(
        (user) => user.id === userOrTeam.iamUserId
      );
      selectedUser && (selectedUser.selected = !selectedUser.selected);
    } else {
      const selectedTeam = newPermissions.teams.find(
        (team) => team.id === userOrTeam._id
      );
      selectedTeam && (selectedTeam.selected = !selectedTeam.selected);
    }

    setPermissions(newPermissions);
  };

  ///////////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////////

  function renderHeader() {
    return (
      <div className="row justify-content-between pt-s pb-s bg-gray3 p-h-m">
        <DKLabel text="Assign record access" className="fw-m" />
        <DKButton
          icon={DKIcons.ic_close}
          className=""
          onClick={props.onClose}
        />
      </div>
    );
  }

  function getShareSection() {
    return (
      <div
        className="scroll-y-only-web hide-scroll-bar border-s border-radius-s m-l border-box mt-xl column flex-shrink-0 justify-content-start flex-1"
        style={{ overflowX: "hidden" }}
      >
        <div className="row p-v-s p-h-r bg-gray1">
          <div
            className="cursor-hand"
            onClick={() => {
              setCurrentView(SHARE_ACTION.USERS);
            }}
          >
            <DKLabel
              text="Org Users"
              className={
                currentView === SHARE_ACTION.USERS ? "fw-m" : "text-gray"
              }
            />
          </div>
          <DKLabel text="|" className="ml-xl mr-xl text-gray" />
          <div
            className="cursor-hand"
            onClick={() => {
              setCurrentView(SHARE_ACTION.TEAMS);
            }}
          >
            <DKLabel
              text="Teams"
              className={
                currentView === SHARE_ACTION.TEAMS ? "fw-m" : "text-gray"
              }
            />
          </div>
        </div>
        <DKLine />
        {currentView === SHARE_ACTION.USERS
          ? userList?.map((user: any) => {
              if (!user.iamUserId) return null;

              const userPerm = permissions?.users?.length
                ? permissions.users.find(
                    (userPermission: any) =>
                      userPermission.id?.toString() ===
                      user.iamUserId?.toString()
                  )
                : null;

              return (<></>
                // <UserTeamRow
                //   user={{
                //     ...user,
                //     permission: userPerm
                //       ? {
                //           ...PERMISSIONS[userPerm.accessLevel],
                //           source: userPerm.source,
                //         }
                //       : PERMISSIONS[ACCESS_LEVEL.NONE],
                //   }}
                //   isOwner={user.iamUserId === currentUserId}
                //   onPermissionSelect={(permission) =>
                //     onPermissionChange(permission, userPerm, false)
                //   }
                //   className={` ${userPerm?.selected ? "-selected" : ""}`}
                //   iconRenderer={(userOrTeam) => (
                //     <DKCheckMark
                //       isSelected={userPerm?.selected}
                //       onClick={(e) => toggleUserOrTeamSelection(e, userOrTeam)}
                //     />
                //   )}
                // />
              );
            })
          : null}
        {currentView === SHARE_ACTION.TEAMS ? (
          teamList?.length === 0 ? (
            <div
              className="row justify-content-center"
              style={{ marginTop: "100px" }}
            >
              <div className="column align-items-center">
                <DKLabel className="text-gray fs-m fw-m" text="No team found" />
                <DKLabel className="text-gray mt-s" text="Create a new team" />
              </div>
            </div>
          ) : (
            teamList.map((team) => {
              if (!team._id) return null;

              const teamPerm = permissions?.teams?.length
                ? permissions.teams.find((item) => item.id === team._id)
                : null;

              return (<></>
                // <UserTeamRow
                //   user={{
                //     ...team,
                //     permission: !teamPerm
                //       ? PERMISSIONS[ACCESS_LEVEL.NONE]
                //       : {
                //           ...PERMISSIONS[teamPerm.accessLevel],
                //           source: teamPerm.source,
                //         },
                //   }}
                //   onPermissionSelect={(permission) =>
                //     onPermissionChange(permission, teamPerm, true)
                //   }
                //   isTeam={true}
                //   onTeamEdit={(team) => {
                //     setSelectedTeamToEdit(team);
                //     setShowAddNewTeam(true);
                //   }}
                //   className={` ${teamPerm?.selected ? "-selected" : ""}`}
                //   iconRenderer={(userOrTeam) => (
                //     <DKCheckMark
                //       isSelected={teamPerm?.selected}
                //       onClick={(e) => toggleUserOrTeamSelection(e, userOrTeam)}
                //     />
                //   )}
                // />
              );
            })
          )
        ) : null}
      </div>
    );
  }

  function getTitle() {
    switch (props.parentStepType) {
      case AUTOMATION_ACTIONS.CREATE_DEAL:
        return "Deal Records getting created after previous action in the workflow";
      case AUTOMATION_ACTIONS.UPDATE_DEAL:
        return "Deal Records getting updated after previous action in the workflow";
      default:
        return "Contact Records associated with previous action/trigger in the workflow";
    }
  }

  function renderBody() {
    return (
      <Fragment>
        <DKLabel
          text={`${getTitle()}, will get assigned to the selected users or teams (with applied permissions) in round robin manner.`}
          className="p-h-l pt-m text-gray fs-r"
        />
        {getShareSection()}
      </Fragment>
    );
  }

  function renderBottom() {
    return (
      <div className="row-reverse pb-l p-h-m">
        <DKButton
          title="Save"
          className="bg-button text-white ml-m"
          onClick={() => {
            saveTapped();
          }}
        />

        <DKButton
          title="Cancel"
          className="bg-gray1 border-m"
          onClick={props.onClose}
        />
        {currentView === SHARE_ACTION.TEAMS ? (
          <DKButton
            title={`+ Create team`}
            className="text-blue fw-m align-self-start mt-s"
            style={{
              marginRight: "auto",
            }}
            onClick={toggleTeamCreationPopup}
          />
        ) : null}
      </div>
    );
  }
  return (
    <div className="transparent-background">
      <div
        className="popup-window align-items-stretch"
        style={{
          padding: 0,
          maxWidth: 450,
          height: 450,
          maxHeight: "90%",
          overflowY: "visible",
        }}
      >
        {renderHeader()}
        {renderBody()}
        {renderBottom()}
        {showAddNewTeam ? (
          <AddTeamPopup
            onTeamCreate={(team) => {
              setShowAddNewTeam(false);
            }}
            onClose={toggleTeamCreationPopup}
            selectedTeam={selectedTeamToEdit}
          />
        ) : null}
      </div>
    </div>
  );
};

export default AssignAccessActionPopup;
